// extracted by mini-css-extract-plugin
export default {"root":"banner_root__xhAup","textInfoBlock":"banner_textInfoBlock__oJwlN","spinAround":"banner_spinAround__CdBAa"};